/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export const MembershipStatusEnum = {
    NonMember: 'nonMember',
    CurrentMember: 'currentMember',
    InactiveMember: 'inactiveMember',
    RemovedMember: 'removedMember',
    ResignedMember: 'resignedMember',
    InReview: 'inReview',
    PendingApproval: 'pendingApproval',
    Rejected: 'rejected',
    AwaitingUpdate: 'awaitingUpdate',
    ApplicationSent: 'applicationSent',
};
